import apiSlice from "./apiSlice";
const keyMilestoneSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    editKeyMilestone: builder.mutation({
      query: ({ id, body }) => ({
        url: `/milestone/${id}`,
        method: "PUT",
        body,
      }),
    }),
    getPendingMilestone: builder.query({
      query: (req) => ({
        url: `milestone/GetWorkFlows`,
        params: req,
      }),
    }),
    updateWorkFlowMilestone: builder.mutation({
      query: (body) => ({
        url: `milestone/UpdateWorkflow`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useEditKeyMilestoneMutation,
  useUpdateWorkFlowMilestoneMutation,
  useGetPendingMilestoneQuery,
} = keyMilestoneSlice;
